<template>
  <div>
    <div id="preloader">
      <div id="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <div id="layout-wrapper">
      <HorizontalTopbarInside />
      <SideBar :is-condensed="isMenuCondensed" :type="leftSidebarType" :width="layoutWidth" />
      <div class="main-content">
        <div class="page-content">
          <!-- Start Content-->
          <div class="container-fluid">
            <slot />
          </div>
        </div>
        <Footer />
        <h2 class="mt-5">{{$t('message.Schools')}}</h2>
        <b-button
            class="btn"
            @click="handlePush"
            variant="outline-info"
            size="lg">
          <i class='bx bxs-plus-square'>{{$t('message.Add')}}</i>
        </b-button>
        <div>
          <b-card
              class="mt-4 d-flex"
          >
            <b-table
                responsive
                style="width: 100%;"
                striped
                hover
                :items="schools"
                :fields="fields">
              <template #cell(status)="data">
                <i class="bx bx-bullseye  font-size-24"></i>
              </template>
              <template #cell(map)="data">
                <i class="bx bx-map font-size-24" @click="handlePush"></i>
              </template>
            </b-table>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Layout from "../../../../../../layouts/main";
import SideBar from "../../../../../../components/side-bar";
import router from "@/router";
import { layoutComputed } from "@/state/helpers";
import {getSchools} from "../../../../../../api/schools";
import HorizontalTopbarInside from "../../../../../../components/horizontal-topbar-inside";


export default {
  name: "Schools",
  components: {
    HorizontalTopbarInside,
    SideBar
  },
  data() {
    return {
      isMenuCondensed: false,
      fields: [
        {
          key: 'organizationid',
          label: this.$t('message.Id')
        },
        {
          key:'organizationfullname',
          label: this.$t('message.Full_name')
        },
        {
          key: 'organizationshortname',
          label: this.$t('message.Short_name')
        },
        {
          key:'oblastname',
          label: this.$t('message.Oblast_name')
        },
        {
          key: 'regionname',
          label: this.$t('message.region_name')
        },
        {
          key:  'organizationtypename',
          label:  this.$t('message.Type_name')
        },
        {
          key:'adress',
          label: this.$t('message.Address')
        },
        {
          key:'director',
          label: this.$t('message.Director')
        },
        {
          key:'contactinfo',
          label: this.$t('message.Contact_info')
        },
        {
          key:'map',
          label: 'map'
        }
      ],
      schools: []
    };
  },
  computed: {
    ...layoutComputed,
  },
  created() {
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-layout-size", "boxed");
    document.body.classList.remove("auth-body-bg");
    this.fetchSchools();
  },
  methods: {
    fetchSchools(){
      getSchools(this.$route.params).then(response => {
        this.schools = response.data.data
      })
    },
    modalClose(){
      this.activeModal = false
      this.fetchSchools()
    },
    closeModal(){
      this.activeModal = false
    },
    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");

      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
          document.body.classList.remove("vertical-collpsed");
        });
        document.body.classList.toggle("vertical-collpsed");
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
        document.body.classList.remove("vertical-collpsed");
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
  },
  mounted() {
    if (this.loader === true) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }, 2500);
    } else {
      document.getElementById("preloader").style.display = "none";
      document.getElementById("status").style.display = "none";
    }
  },
}
</script>

<style scoped>
h2{
  margin-left: 70px;
  margin-bottom: 50px;
  color: #4d63cf;
}
.btn{
  width: 140px;
  height: 50px;
  margin-left: 70px;
}
.bx{
  font-size: 19px;
}
</style>



